import axios from 'axios'

export default {
  // 요금제 상품목록
  getPricingProduct (cb) {
    axios.get('biz/pricing/product/')
      .then((response) => {
        // 정상적으로 데이터 전송한 경우
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('can`t get PricingList!', response)
        }
      })
      .catch((response) => {
        response.error = true
        cb(response)
      })
  },

  // 카드 결제 기본 정보
  getBasicOrderInfo (data, cb) {
    axios.post('/biz/pricing/charge/get_order_basic_info/', data)
      .then(function (response) {
        // 정상적으로 데이터 전송한 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('can`t apply insurance!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 이지페이 요청
  easypayRequest (data, cb) {
    axios.post('/biz/pricing/charge/easypay_request/', data)
      .then(function (response) {
        // 정상적으로 데이터 전송한 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('can`t apply insurance!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/pricing.js